import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M5 18l14 -4","key":"svg-0"}],["path",{"d":"M5 14l14 -4l-14 -4","key":"svg-1"}]]

const IconMathEqualGreater = createReactComponent('outline', 'math-equal-greater', 'MathEqualGreater', __iconNode);

export default IconMathEqualGreater;